import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const submitQuote = (payload) => api.post("/quotes", payload).then((r) => r.data);

export const startCheckout = async (cart) => {
  const items = cart.map((i) => ({ id: i.id, quantity: i.quantity, start: i.start || null, end: i.end || null }));
  const { data } = await api.post("/checkout/session", { items, origin_url: window.location.origin });
  if (!data.url) throw new Error("no url");
  window.location.href = data.url;
};

export const getCheckoutStatus = (sessionId) =>
  api.get(`/checkout/status/${sessionId}`).then((r) => r.data);
